import { FormEvent } from "react";
import { Box } from "@mui/material";
import { useTranslation } from "next-i18next";
import { InvestableInCountrySwitch } from "src/components/pages/search/components/investable-in-country-switch";
import { handleIsInvestable } from "src/components/pages/search/store/actions";
import { useSearchStore } from "src/components/pages/search/store/search-store";
import { SwitchWithLabel } from "src/components-mui/base/switch-with-label/switch-with-label";
import { EnumCountryKey } from "src/types/common-enum";
import { useRouterLocale } from "src/utils/router/use-router-locale";

export const SearchFilterInvestableSwitches = () => {
    const { country } = useRouterLocale();
    const { t } = useTranslation("common");
    const { isInvestable } = useSearchStore();

    if (country === EnumCountryKey.INT) {
        return null;
    }

    const onChangeInvestable = (event: FormEvent<HTMLInputElement>) => {
        handleIsInvestable({ isChecked: event.currentTarget.checked });
    };

    return (
        <Box
            sx={{
                display: "flex",
                flexDirection: "row",
                gap: 5,
            }}
        >
            <SwitchWithLabel
                size="small"
                fontSize="sm"
                onChange={onChangeInvestable}
                label={t("labels.investable-wikifolios-only")}
                checked={isInvestable}
            />
            <InvestableInCountrySwitch />
        </Box>
    );
};
